import React from 'react';

import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { basketUtils } from 'components/organisms/Basket/utils/basketUtils';
import { TranslateFunction } from 'react-localize-redux';

import { Typography } from '../../../components/atoms';
import { BasketItem, GroupHeader } from '../../../components/molecules';
import { Currency } from '../../../core/api/general/general.types';
import { ConcessionStore } from '../../../core/api/restaurant/restaurant.types';

const useStyles = makeStyles((theme: Theme) => ({
  orderedItemsList: {
    '& ul': {
      padding: 0,
    },
  },
  yourOrder: {
    '& .fd-text': {
      marginBottom: theme.spacing(1.5),
    },
  },
}));

type OrderedItemsListProps = {
  basketSummary: any;
  concessionStores: ConcessionStore[];
  currency: Currency;
  languageCode: string;
  menuId: number;
  translate: TranslateFunction;
};

export function OrderedItemsList(props: OrderedItemsListProps): JSX.Element {
  const {
    basketSummary,
    concessionStores,
    currency,
    languageCode,
    menuId,
    translate,
  } = props;

  const classes = useStyles();

  const hasConcessionStores = concessionStores && concessionStores.length > 0;
  const basketSummaryItems = basketSummary.basketItems;

  const concessionStoresArr = hasConcessionStores ? concessionStores : [];

  const renderListItem = (basketItem): JSX.Element => (
    <li key={basketItem.index}>
      <BasketItem
        basketItem={basketItem}
        currency={currency}
        hasQuantityControl={false}
        languageCode={languageCode}
        menuId={menuId}
        translate={translate}
      />
    </li>
  );

  const renderItemsList = (): JSX.Element =>
    basketSummary.summary.map((item) => {
      const basketItem = {
        index: item.item.index,
        item: item.item.item.Item,
        options: item.item.item.Options,
        quantity: item.item.quantity,
      };

      return renderListItem(basketItem);
    });

  const refactoredBasketSnapshotItems =
    basketUtils.refactorBasketSnapshot(basketSummaryItems);

  const summarisedBasketItems = basketUtils.summariseConcessionBasketItems(
    refactoredBasketSnapshotItems,
  );

  const renderConcessionBrand = (id, concessionStoresArray): JSX.Element => {
    const concessionBrand = basketUtils.getConcessionBrand(
      id,
      concessionStoresArray,
    );
    return (
      <li>
        <GroupHeader
          src={concessionBrand?.ImageUrl}
          title={concessionBrand?.Name}
        />
      </li>
    );
  };

  const renderOrderedConcessionItems = (concessionItems) =>
    concessionItems.map((item) => {
      const basketItem = {
        index: item.itemData.index,
        item: item.itemData.item,
        options: item.itemData.options,
        quantity: item.itemData.quantity,
      };

      return renderListItem(basketItem);
    });

  const renderConcessionItemsList = () =>
    Object.entries(summarisedBasketItems).map(([storeId, items]: any) => (
      <li key={storeId}>
        <ul>
          {renderConcessionBrand(Number(storeId), concessionStoresArr)}
          {renderOrderedConcessionItems(items)}
        </ul>
      </li>
    ));

  return (
    <>
      <li className={classes.yourOrder}>
        <Typography variant="body2-secondary">
          {translate('Your_order')}
        </Typography>
      </li>

      <li className={classes.orderedItemsList}>
        <ul>
          {hasConcessionStores
            ? renderConcessionItemsList()
            : renderItemsList()}
        </ul>
      </li>
    </>
  );
}
